<template>
  <div
    id="home"
    class="amp-mask"
  >
    <FloatingNav
      v-if="floatingNavActive"
      :floating-nav="homepage.floating_nav"
    />
    <cms-gallery
      v-if="galleryHasImagesOrVideo"
      :theme="galleryOptions"
      :gallery="homepage.gallery"
      :class="{ 'accent-styling': accentStyling }"
    />
    <div
      v-for="(container, index) in homepageContainers"
      :key="index"
      class="main"
    >
      <Container
        :container="container"
        :container-idx="container.containerIndex"
        :is-last-container="isLastContainer(index)"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useMainStore } from '../stores/mainStore.js';
import get from 'lodash/get';
import Container from './home_page/ViewContainer.vue';
import FloatingNav from './home_page/floating_nav/ViewFloatingNav.vue';

defineOptions({
  name: 'ViewHomepage',
});

const mainStore = useMainStore();

const theme = computed(() => mainStore.theme);
const homepage = computed(() => mainStore.homepage);
const accentStyling = computed(() => mainStore.accentStyling);
const getGlobalThemeSettings = computed(() => mainStore.getGlobalThemeSettings);

const floatingNavActive = computed(() => get(theme.value, 'floating_nav.options.active', false));

const galleryOptions = computed(() => ({
  ...theme.value.gallery.options,
  globalThemeSettings: getGlobalThemeSettings.value,
  hasFloatingNav: floatingNavActive.value,
}));

const galleryHasImagesOrVideo = computed(() => {
  const getItemType = (item) => item && item.split('?')[0].split('.').pop();
  const firstSlideIsVideo = ['webm', 'mp4'].includes(getItemType(homepage.value.gallery.slides?.[0]?.url));

  if (galleryOptions.value.use_video && ['G2', 'G7'].includes(galleryOptions.value.version)) {
    return firstSlideIsVideo;
  }
  if (firstSlideIsVideo) {
    return false;
  }
  return homepage.value.gallery?.slides?.length >= 1;
});

const homepageContainers = computed(() => {
  if (!theme.value?.containers) return [];
  const containersWithIndex = theme.value.containers.map((container, idx) => ({
    ...container,
    containerIndex: idx,
  }));
  return containersWithIndex.filter((container) => !container.global);
});

function isLastContainer(index) {
  return theme.value?.containers && index === theme.value.containers.length - 1;
}
</script>

<style scoped>
.main .container {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  -o-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: space-between;
  -webkit-box-pack: space-between;
  -moz-box-pack: space-between;
  -ms-flex-pack: space-between;
  justify-content: space-between;
}
</style>
